import {
  MRT_GlobalFilterTextField as MRTGlobalFilterTextField,
  MRT_ShowHideColumnsButton as MRTShowHideColumnsButton,
  MRT_TableInstance,
  MRT_ToggleFiltersButton as MRTToggleFiltersButton
} from "material-react-table";
import { useTranslation } from "react-i18next";
import { Button, Grid2, IconButton, Tooltip, Typography } from "@mui/material";
import { AddBox, Delete } from "@mui/icons-material";

type Props = {
  table: MRT_TableInstance<any>;
  /** When provided, a headline is shown on the left and layout uses space-between; otherwise toolbar is end-aligned. */
  usedHeadlineKey?: string;
  disabledDeleteButton: boolean;
  addItemLabel: string;
  onDelete: () => void;
  /** When set, opens create flow outside the table instead of MRT inline create row. */
  onAddClick?: () => void;
};
export const EditableCategoryListToolbar = ({
  table,
  usedHeadlineKey,
  disabledDeleteButton,
  addItemLabel,
  onDelete,
  onAddClick
}: Props) => {
  const { t } = useTranslation();
  const showHeadline = usedHeadlineKey != null && usedHeadlineKey !== "";

  return (
    <Grid2
      container
      sx={{
        display: "flex",
        p: 2,
        alignItems: "center",
        justifyContent: showHeadline ? "space-between" : "end"
      }}
    >
      {showHeadline && (
        <Typography variant={"h5"} sx={{ fontWeight: 600, whiteSpace: "nowrap" }}>
          {t(usedHeadlineKey)}
        </Typography>
      )}

      <Grid2 sx={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
        {/* import MRT sub-components */}
        <MRTGlobalFilterTextField table={table} />
        <MRTToggleFiltersButton table={table} />
        <MRTShowHideColumnsButton table={table} />

        {/* multi deletion */}
        <Tooltip
          title={<Typography>{t("Delete selection")}</Typography>}
          aria-label={"Delete selection"}
        >
          <span>
            <IconButton
              color={"error"}
              data-testid="handle-multidelete-category-btn"
              disabled={disabledDeleteButton}
              onClick={onDelete}
              size="large"
            >
              <Delete />
            </IconButton>
          </span>
        </Tooltip>

        {/* add new category button */}
        <Button
          data-testid="Add-new-category-btn"
          onClick={() => (onAddClick ? onAddClick() : table.setCreatingRow(true))}
          sx={{ height: "fit-content", alignSelf: "center", p: "6px 12px" }}
        >
          <AddBox sx={{ mr: 1 }} />
          {t(addItemLabel)}
        </Button>
      </Grid2>
    </Grid2>
  );
};
